/**
 * O card do ponto de encontro — na Home (durante) e no Mapa. Quem marcou,
 * onde, quando; "Cheguei"; quem já chegou; "Como chegar"; encerrar.
 */
import { useState } from 'react';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { FotoAvatar } from '../perfil/FotoAvatar';
import { usePessoas } from '../roteiro/people';
import { Card } from '../../ui/primitives';
import { ComoChegar } from '../mapa/ComoChegar';
import { type Encontro, encontroApi, useInvalidarEncontro } from './api';

function hora(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function EncontroCard({ encontro }: { encontro: Encontro }) {
  const { fotoDe } = usePessoas();
  const { tripId, members } = useTrip();
  const avisar = useInvalidarEncontro(tripId);
  const [mexendo, setMexendo] = useState(false);
  const total = members.length;
  const chegaram = new Set(encontro.arrivals.map((a) => a.memberId));
  const faltam = members.filter((m) => !chegaram.has(m.memberId));

  async function agir(fn: () => Promise<unknown>) {
    setMexendo(true);
    try {
      await fn();
      avisar();
    } finally {
      setMexendo(false);
    }
  }

  return (
    <Card className="enc" data-testid="encontro">
      <div className="enc__cab">
        <span className="enc__icone" aria-hidden="true"><Icon name="ponto" size={18} /></span>
        <span className="mapa__pessoa-texto">
          <span className="enc__titulo">{encontro.title}</span>
          <span className="mapa__pessoa-familia">
            <span className="mono">{hora(encontro.at)}</span> · marcado por {encontro.createdBy.name} · {encontro.arrivals.length} de {total} {encontro.arrivals.length === 1 ? 'chegou' : 'chegaram'}
          </span>
        </span>
      </div>
      <div className="fin__ctas">
        <ComoChegar destino={{ locationName: encontro.title, latitude: encontro.latitude, longitude: encontro.longitude }} />
        {encontro.iArrived ? (
          <span className="nv-btn nv-btn--secondary enc__cheguei" aria-live="polite">
            <Icon name="concluir" size={16} /> Você chegou
          </span>
        ) : (
          <button type="button" className="nv-btn nv-btn--primary" disabled={mexendo} onClick={() => void agir(() => encontroApi.cheguei(tripId, encontro.id))}>
            Cheguei
          </button>
        )}
      </div>
      {encontro.arrivals.length > 0 && (
        <div className="enc__lista">
          <span className="nv-avatar-stack">
            {encontro.arrivals.slice(0, 6).map((a) => (
              <FotoAvatar key={a.memberId} nome={a.name} url={fotoDe(a.memberId).url} cor={fotoDe(a.memberId).cor} tamanho={20} className="bag__mini-avatar" />
            ))}
          </span>
          <span className="mapa__pessoa-familia">
            {encontro.arrivals.map((a) => a.name).join(', ')}
            {faltam.length > 0 && ` · faltam ${faltam.length}`}
          </span>
        </div>
      )}
      {encontro.canClose && (
        <button type="button" className="nv-btn nv-btn--ghost nv-btn--block" disabled={mexendo} onClick={() => void agir(() => encontroApi.encerrar(tripId, encontro.id))}>
          Encerrar ponto de encontro
        </button>
      )}
    </Card>
  );
}
